declare namespace $ {

	export class $mol_icon_account_group extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=group.view.tree.d.ts.map